// @flow

import { push } from 'connected-react-router';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Modal from '../../../modal';
import Colors from '../../../config/atoms/choiceGroups/colors';
import { hasAlternativeColors } from '../../../../store/configuration/actives/selectors';
import { getOutOfStockHistory } from '../../../../store/orderForm/selectors';
import ButtonBar from '../../../buttonBar';
import Button from '../../../button';
import type {
  DispatchProps,
  OwnProps,
  Props,
  StateProps,
} from './types';
import type { Theme } from '../../../../types';

const ColorWrapper = styled<any, Theme>('div')`
  margin: 1.5rem 0;
`;

const OutOfStockTextWrapper = styled<any, Theme>('p')`
  margin-bottom: 1.5rem;
`;

const AlternativesModal = ({
  pdbId,
  alternativeColorsAvailable,
  outOfStockHistory,
  overlayTitle,
  onClose,
  alternativeText,
  outOfStockText,
  selectColorButtonText,
  navigationButtonText,
  navigationButtonLink,
  redirect,
}: Props) => (
  <>
    <Modal
      isOpen
      onClose={onClose}
      closeOnOverlayClick={false}
      ariaLabel="label"
      title={overlayTitle}
      size="medium"
    >
      <>
        {alternativeColorsAvailable && (
          <>
            <p>{alternativeText}</p>
            <ColorWrapper>
              <Colors
                pdbId={pdbId}
                excludeColorIds={outOfStockHistory}
              />
            </ColorWrapper>
            <ButtonBar justify="space-between">
              <Button onClick={onClose}>{selectColorButtonText}</Button>
              <Button onClick={() => redirect(navigationButtonLink)}>{navigationButtonText}</Button>
            </ButtonBar>
          </>
        )}
        {!alternativeColorsAvailable && (
          <>
            <OutOfStockTextWrapper>
              {outOfStockText}
            </OutOfStockTextWrapper>
            <section>
              <Button onClick={() => redirect(navigationButtonLink)}>{navigationButtonText}</Button>
            </section>
          </>
        )}
      </>
    </Modal>
  </>
);

const mapStateToProps = (state): StateProps => ({
  alternativeColorsAvailable: hasAlternativeColors(state),
  outOfStockHistory: getOutOfStockHistory(state),
  overlayTitle: 'Alternatieven',
  selectColorButtonText: 'Selecteer kleur',
  navigationButtonText: 'Toon alle modellen',
  navigationButtonLink: '/modellen',
  alternativeText: 'Helaas is dit model niet meer beschikbaar in de gekozen kleur. U kunt een keuze maken uit onderstaande alternatieven.',
  outOfStockText: 'Helaas is dit model niet meer beschikbaar.',
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  redirect: (url: string) => dispatch(push(url)),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(AlternativesModal);
